export default "__VITE_ASSET__sT30YV_b__"